import { useId } from 'react';
import {
  PRO_MARK_ASPECT,
  PRO_MARK_WIDTH,
  proMarkSvg,
} from './pro-mark';

interface ProIconProps {
  /** Square edge while `boxed`; the mark's own width once `boxed` is off. */
  size?: number;
  /** Flat tint. Omit for the design's violet ramp. */
  color?: string;
  /** See ProIcon.tsx: the legacy padded square, and the default. */
  boxed?: boolean;
}

/**
 * Web twin of ProIcon.tsx, which renders through react-native-svg's SvgXml and
 * therefore cannot run here (same reason as SuggestionIcons.web.tsx). Both
 * platforms emit the same bytes from `pro-mark.ts`, so the mark cannot drift.
 *
 * This is the brand mark, not an icon-library glyph: web used to draw a
 * Material Symbols "diamond" here, which is a different shape entirely.
 */
export function ProIcon({
  size = PRO_MARK_WIDTH,
  color,
  boxed = true,
}: ProIconProps) {
  // `useId` emits characters that are not valid inside an SVG url(#id).
  const id = `proMark${useId().replace(/[^a-zA-Z0-9]/g, '')}`;
  const height = boxed ? size : size / PRO_MARK_ASPECT;

  return (
    <span
      aria-hidden
      style={{
        display: 'block',
        flexShrink: 0,
        width: size,
        height,
        lineHeight: 0,
      }}
      dangerouslySetInnerHTML={{
        __html: proMarkSvg({
          id,
          tint: color,
          boxed,
          width: size,
          height,
        }),
      }}
    />
  );
}
